import { render, staticRenderFns } from "./TheFloatButton.vue?vue&type=template&id=463b2848"
import script from "./TheFloatButton.vue?vue&type=script&lang=js"
export * from "./TheFloatButton.vue?vue&type=script&lang=js"
import style0 from "./TheFloatButton.vue?vue&type=style&index=0&id=463b2848&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports